import React, { useState, useEffect } from "react";

import authService, { user$ } from "../../../utils/services/authService";
import styles from "./adminDashboard.module.scss";
import UserLayout from "../../../components/user-layout/UserLayout";
import adminService from "../../../utils/services/adminService";
import {
  getDevData,
  ticketCalc,
  jobCalc,
} from "../../../utils/helper-functions/adminHelpers";
import { NavLink } from "react-router-dom";

const AdminDashboard = () => {
  const [user, setUser] = useState();
  const [stats, setStats] = useState();
  const [devStats, setDevStats] = useState();
  // const [compStats, setCompStats] = useState();
  const [ticketStats, setTicketStats] = useState();
  const [jobStats, setJobStats] = useState();
  const [pendingTickets, setPendingTickets] = useState();

  const userData = authService.getUserData();

  useEffect(() => {
    const loggedIn = authService.checkLoggedIn();

    if (loggedIn) {
      if (userData.token !== undefined) {
        authService.getUserById(userData);

        user$.subscribe((data) => {
          if (user !== data) {
            setUser(data.data.data[0]);
          }
        });

        adminService.getStats(userData).then((res) => {
          setStats(res.data.data);
        });
      }
    }
  }, []);

  useEffect(() => {
    if (stats) {
      setDevStats(getDevData(stats?.developers));
      setTicketStats(ticketCalc(stats?.tickets));
      setJobStats(jobCalc(stats?.jobs, stats?.developers));
      setPendingTickets(getPendingTickets(stats?.tickets));
    }
  }, [stats]);

  const getPendingTickets = (arr) => {
    let newArr = [];
    arr.forEach((ticket) => {
      if (ticket.closed === false) {
        newArr.push(ticket);
      }
    });
    return newArr;
  };

  return (
    <>
      <UserLayout>
        <section className={styles.adminDashWrapper}>
          <section className={styles.top}>
            <div className={styles.platformStats}>
              <h3 className={styles.platformStats_heading}>
                Platform statistics
              </h3>
              <div className={styles.platformStats_top}>
                <div className={styles.dev}>
                  <p className={styles.dev_title}>Developers</p>
                  <p className={styles.dev_value}>{devStats?.total}</p>
                </div>
                <div className={styles.company}>
                  <p className={styles.company_title}>Companies</p>
                  <p className={styles.dev_value}>{stats?.companies.length}</p>
                </div>
              </div>
              <div className={styles.platformStats_bottom}>
                <div className={styles.left}>
                  <p className={styles.left_title}>Men</p>
                  <p className={styles.left_value}>
                    {devStats?.males.toFixed(2)}%
                  </p>
                </div>
                <div className={styles.right}>
                  <p className={styles.right_title}>Women</p>
                  <p className={styles.right_value}>
                    {devStats?.females.toFixed(2)}%
                  </p>
                </div>
              </div>
            </div>
            <section className={styles.tickets}>
              <h3 className={styles.tickets_heading}>Tickets</h3>
              <div className={styles.top}>
                <div className={styles.top_left}>
                  <p className={styles.title}>Pending</p>
                  <p className={styles.value}>{ticketStats?.pending}</p>
                </div>
                <div className={styles.top_right}>
                  <p className={styles.title}>Completed</p>
                  <p className={styles.value}>{ticketStats?.completed}</p>
                </div>
              </div>
              <div className={styles.bottom}>
                <p className={styles.bottom_title}>Total tickets</p>
                <p className={styles.bottom_value}>{ticketStats?.total}</p>
              </div>
            </section>
          </section>

          <section className={styles.bottom}>
            <section className={styles.jobs}>
              <h3 className={styles.jobs_heading}>Jobs</h3>
              <div className={styles.jobsInner}>
                <div className={styles.left}>
                  <p className={styles.left_title}>Open jobs</p>
                  <p className={styles.left_value}>{jobStats?.total}</p>
                </div>
                <div className={styles.right}>
                  <p className={styles.right_title}>Applied jobs</p>
                  <p className={styles.right_value}>{jobStats?.appliedJobs}</p>
                </div>
              </div>
            </section>
            <section className={styles.pendingTickets}>
              <h3 className={styles.pendingTickets_heading}>Pending tickets</h3>
              {pendingTickets?.map((ticket, index) => (
                <NavLink
                  key={index}
                  className={styles.link}
                  to={`/admin/tickets/${ticket._id}`}
                >
                  <div className={styles.card} key={index}>
                    <h4 className={styles.card_name}>{ticket.subject}</h4>
                    <p className={styles.card_timestamp}>{ticket.createdAt}</p>
                    <p className={styles.card_category}>{ticket.category}</p>
                    <p className={styles.card_description}>
                      Hi, I can't see any jobs when going to jobs page
                    </p>
                  </div>
                </NavLink>
              ))}
            </section>
          </section>
        </section>
      </UserLayout>
    </>
  );
};

export default AdminDashboard;
